import React from 'react';
import { TWModal } from '../../../../components/ui';

const sizeMap = {
  'sm:max-w-sm': 'sm',
  'sm:max-w-md': 'md',
  'sm:max-w-lg': 'lg',
  'sm:max-w-xl': 'xl',
  'sm:max-w-2xl': '2xl',
  'sm:max-w-3xl': '3xl',
  'max-w-md': 'md',
  'max-w-lg': 'lg',
  'max-w-xl': 'xl',
  'max-w-2xl': '2xl',
};

const DialogShell = ({
  open,
  onClose,
  children,
  maxWidth = 'sm:max-w-lg',
  initialFocus,
}) => (
  <TWModal
    open={open}
    onClose={onClose || (() => {})}
    size={sizeMap[maxWidth] || 'lg'}
    initialFocus={initialFocus}
    bodyClassName="p-0"
  >
    {children}
  </TWModal>
);

export default DialogShell;
